import ScreenBarPartner from "./components/screen-bar-partner";
import Fireworks from "@fireworks-js/react";
import ScreenDonSection from "./components/screen-don-section";
import {useEffect} from "react";


export default function CustomPerp({context,loading, campagneData})
{

    const screenOptions=campagneData?.screenOptions || {}
    const org=context.org

    useEffect(() => {
        document.body.style.overflow="hidden";
        document.body.style.cursor="none";
    }, []);


    if(loading)
    {
        return (
            <div className="screen" style={{aspectRatio: "16/9", position: "relative"}}>
                <div className={"screen-background"}>
                </div>
            </div>
        )
    }


    return (
        <div className="screen" style={{aspectRatio: "16/9", position: "relative"}}>
            <div className={"screen-background"}>
                <img src={"/campagne/screen/custom-perp/bg.jpg"}
                       style={{height: "100vh", width: "100vw"}}/>
            </div>

            <div className={"screen-content"}>
                <div style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                }}>

                    <div style={{marginTop: "8vh",width:"100%",border:"0px solid red"}}>
                        <ScreenBarPartner context={context} campagneData={campagneData} mini={screenOptions.barMini}/>
                    </div>


                    <div style={{marginTop: "10vh",width:"100%"}}>
                        <ScreenDonSection context={context} campagneData={campagneData}/>
                    </div>


                    {screenOptions.forceCelebration &&(
                        <Fireworks
                            autostart
                            options={{intensity:30,particles:100,traceLength:1,opacity:0.2}}
                            style={{
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                position: 'fixed',
                                background: 'transparent'
                            }}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}
